/**
 * Mega menu hover behavior:
 * - Our Culture (3 levels): Hover 2nd level → show 3rd level panel. Hover 3rd level → show content.
 * - Shop (2 levels): Hover 2nd level → show 3 products.
 */
(function () {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  function initMegaMenu(headerMenu) {
    const megaMenu = headerMenu.querySelector('.mega-menu');
    if (!megaMenu) return;

    const content = megaMenu.querySelector('.mega-menu__content');
    if (!content) return;

    const hasGrandchildren = headerMenu.getAttribute('data-has-grandchildren') === 'true';

    const level2Items = content.querySelectorAll('.mega-menu__level-2-item');
    const level3Panels = content.querySelectorAll('.mega-menu__level-3-panel');
    const level3Links = content.querySelectorAll('.mega-menu__link--level-3[data-handle]');
    const contentPanels = content.querySelectorAll('.mega-menu__content-panel[data-handle]');

    const level2Links = content.querySelectorAll('.mega-menu__link--level-2[data-handle]');

    function showLevel3Panel(parentHandle) {
      level3Panels.forEach((panel) => {
        panel.hidden = !parentHandle || panel.dataset.parent !== parentHandle;
      });
    }

    function showContentPanel(handleOrHandles) {
      const handlesToMatch = Array.isArray(handleOrHandles)
        ? handleOrHandles.map((h) => (h || '').toLowerCase()).filter(Boolean)
        : [(handleOrHandles || '').toLowerCase()];
      contentPanels.forEach((panel) => {
        const panelHandle = (panel.dataset.handle || '').toLowerCase();
        const matches = panelHandle && handlesToMatch.some((h) => h === panelHandle);
        panel.hidden = !matches;
      });
    }

    function getLevel2MatchHandles(item) {
      const handles = [item.dataset.childHandle, item.dataset.titleHandle, item.dataset.collectionHandle].filter(Boolean);
      return [...new Set(handles)];
    }

    function setActiveLevel2(activeItem) {
      level2Items.forEach((item) => {
        item.classList.toggle('mega-menu__level-2-item--active', item === activeItem);
      });
    }

    function setActiveLevel3(handle) {
      level3Links.forEach((link) => {
        if (link.dataset.handle === handle) {
          link.classList.add('mega-menu__link--active');
        } else {
          link.classList.remove('mega-menu__link--active');
        }
      });
    }

    const level3Column = content.querySelector('.mega-menu__column--level-3');

    function resetAll() {
      level3Panels.forEach((p) => { p.hidden = true; });
      contentPanels.forEach((p) => { p.hidden = true; });
      level2Items.forEach((item) => item.classList.remove('mega-menu__level-2-item--active'));
      level3Links.forEach((link) => link.classList.remove('mega-menu__link--active'));
      if (level3Column) level3Column.classList.remove('mega-menu__column--hidden');
    }

    function showFirstLevel2Item() {
      const firstItem = level2Items[0];
      if (!firstItem) return;
      const handle = firstItem.dataset.childHandle;
      const hasChildren = firstItem.dataset.hasChildren === 'true';
      setActiveLevel2(firstItem);
      if (hasGrandchildren) {
        if (hasChildren) {
          showLevel3Panel(handle);
          const firstPanel = content.querySelector(`.mega-menu__level-3-panel[data-parent="${handle}"]`);
          if (firstPanel) {
            const firstLink = firstPanel.querySelector('.mega-menu__link--level-3[data-handle]');
            if (firstLink) {
              showContentPanel(firstLink.dataset.handle);
              setActiveLevel3(firstLink.dataset.handle);
            }
          }
        } else {
          showLevel3Panel(null);
        }
      } else {
        const handles = getLevel2MatchHandles(firstItem);
        showContentPanel(handles);
      }
    }

    if (hasGrandchildren) {
      // Our Culture: 3 levels
      level2Items.forEach((item) => {
        const link = item.querySelector('.mega-menu__link--level-2');
        const childHandle = item.dataset.childHandle;
        const hasChildren = item.dataset.hasChildren === 'true';

        if (!link) return;

        link.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          setActiveLevel2(item);
          if (hasChildren) {
            showLevel3Panel(childHandle);
            const firstPanel = content.querySelector(`.mega-menu__level-3-panel[data-parent="${childHandle}"]`);
            if (firstPanel && !firstPanel.hidden) {
              const firstLink = firstPanel.querySelector('.mega-menu__link--level-3[data-handle]');
              if (firstLink) {
                showContentPanel(firstLink.dataset.handle);
                setActiveLevel3(firstLink.dataset.handle);
              }
            }
          } else {
            showLevel3Panel(null);
            showContentPanel([]);
            setActiveLevel3(null);
          }
        });
      });

      level3Links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          const handle = link.dataset.handle;
          showContentPanel(handle);
          setActiveLevel3(handle);
        });
      });
      // No content mouseenter - it would reset active state when moving to content area
    } else {
      // Shop: 2 levels, show products on 2nd level hover
      level2Items.forEach((item) => {
        const link = item.querySelector('.mega-menu__link--level-2');
        if (!link) return;
        link.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          const handles = getLevel2MatchHandles(item);
          showContentPanel(handles);
          setActiveLevel2(item);
        });
      });
      // No content mouseenter for Shop - it would reset active state when moving to products column
    }

    const details = megaMenu.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) {
          showFirstLevel2Item();
        } else {
          resetAll();
        }
      });
    }
  }

  function initProductCardSwatches() {
    document.querySelectorAll('.mega-menu__product-card').forEach((card) => {
      if (card.dataset.swatchesInit) return;
      card.dataset.swatchesInit = 'true';

      const mainImage = card.querySelector('.mega-menu__product-card__image');
      const secondaryImage = card.querySelector('.mega-menu__product-card__image--secondary');
      const priceEl = card.querySelector('.mega-menu__product-card__price');
      const swatches = card.querySelectorAll('.mega-menu__product-card__swatch');

      if (!mainImage || !priceEl || swatches.length === 0) return;

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const imageUrl = swatch.dataset.variantImage;
          const secondaryImageUrl = swatch.dataset.variantSecondaryImage;
          const price = swatch.dataset.variantPrice;
          const variantId = swatch.dataset.variantId;
          const alt = swatch.dataset.variantAlt || '';

          if (imageUrl) {
            mainImage.src = imageUrl;
            mainImage.removeAttribute('srcset');
          }
          if (secondaryImage && secondaryImageUrl) {
            secondaryImage.src = secondaryImageUrl;
            secondaryImage.removeAttribute('srcset');
          }
          if (alt) mainImage.alt = alt;
          if (alt && secondaryImage) secondaryImage.alt = alt;
          if (price) priceEl.textContent = price;
          if (variantId && card.href) {
            const baseUrl = card.href.split('?')[0];
            card.href = baseUrl + '?variant=' + variantId;
          }

          swatches.forEach((s) => s.classList.remove('mega-menu__product-card__swatch--active'));
          swatch.classList.add('mega-menu__product-card__swatch--active');
        });
      });
    });
  }

  function init() {
    if (!isDesktop()) return;
    document.querySelectorAll('header-menu .mega-menu').forEach((megaMenu) => {
      const headerMenu = megaMenu.closest('header-menu');
      if (headerMenu && !headerMenu.dataset.megaMenuInit) {
        headerMenu.dataset.megaMenuInit = 'true';
        initMegaMenu(headerMenu);
      }
    });
    initProductCardSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', () => {
    if (!isDesktop()) return;
    init();
  });
})();
